import {Component, Input, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {RuleDialog} from '../rule-dialog/rule-dialog.component';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'rule-condition',
  template: `
        <div class="row" [formGroup]="condition" style="width: 500px; display: flex;">
          <div class="col s2">
            <mat-form-field class="form-field">
            <mat-select formControlName="logicOperator"
                        placeholder="Action">
              <mat-option *ngFor="let logic of condLogic" [value]="logic.value">
                {{ logic.label }}
              </mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="col s1">
            <mat-form-field class="form-field">
            <mat-select (selectionChange)="changeProp($event)"
                        placeholder="Field"
                        formControlName="name"
                        placeholder="Chose product">
              <mat-option *ngFor="let product of condProp" [value]="product.value">
                {{ product.label }}
              </mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="col s1">
            <mat-form-field class="form-field">
            <mat-select formControlName="operator"
                        placeholder="Operator">
              <mat-option *ngFor="let cond of condCompare" [value]="cond.value">
                {{ cond.label }}
              </mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="col s1" *ngIf="condition.get('name').value === 'product_id'; else value">
            <mat-form-field class="form-field">
            <mat-select placeholder="Value" formControlName="value">
              <mat-optgroup *ngFor="let group of condPropVal" [label]="group.label">
                <mat-option *ngFor="let product of group.products" [value]="product.id.toString()">
                  {{ product.name }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
            </mat-form-field>
          </div>
          <ng-template #value>
            <div class="col s1" *ngIf="propValType == 'select'">
              <mat-form-field class="form-field">
              <mat-select formControlName="value"
                          placeholder="Value">
                <mat-option *ngFor="let propVal of condPropVal" [value]="getOptionValue(propVal.value)">
                  {{ propVal.label }}
                </mat-option>
              </mat-select>
              </mat-form-field>
            </div>
          </ng-template>
          <div class="col s1 input-fld" *ngIf="propValType == 'input'">
            <mat-form-field class="form-field">
              <input matInput formControlName="value" placeholder="Value">
            </mat-form-field>
          </div>
        </div>
        `,
  styles: [`
    .form-field {
      width: 95px;
    }
        mat-form-field{
            margin: 0 10px;
        }
    `]
})

export class RuleCondition implements OnInit {
  @Input('group') public condition: FormGroup;
  @Input('count') public count: number;
  @Input('cond') public cond: any;
  constructor(public dialogRef: MatDialogRef<RuleDialog>, private _fb: FormBuilder) {
  }

  condLogic: any = [{value: '', label: ''}];
  condCompare: any = [{value: '', label: ''}];
  condLessMore: any = [];
  condEqual: any = [];
  condProp: any = [{value: '', label: ''}];
  condPropVal: any = [];

  propValType = 'select';

  ngOnInit() {
    this.condLogic = this.cond['condLogic'];

    this.condCompare = this.cond['condCompare'];
    this.condLessMore = this.cond['condCompare'];
    this.condEqual = [this.cond['condCompare'][0], this.cond['condCompare'][1]];
    this.condProp = this.cond['condProp'];
    for (const i in this.cond['condProp']) {

    }

    if (this.condition['controls']['value'].value) {
      const field = this.condition['controls']['name'].value;
      const prop = this.cond['condPropVal'][field];
      if (typeof prop === 'string' && prop === 'input') {
        this.condPropVal = [];
        this.propValType = 'input';
        this.condCompare = this.condLessMore;
      } else if (typeof prop === 'object') {
        this.condPropVal = prop;
        this.propValType = 'select';
        this.condCompare = this.condEqual;
      }
    }
  }

  changeProp(data) {
    const prop: any = this.cond['condPropVal'][data['value']];
    if (typeof prop === 'string' && prop === 'input') {
      this.condPropVal = [];
      this.condition.controls['value'].patchValue('');
      this.propValType = 'input';
      this.condCompare = this.condLessMore;
    } else if (typeof prop === 'object') {
      this.condPropVal = prop;
      this.propValType = 'select';
      this.condCompare = this.condEqual;
    }
  }
  getOptionValue(value) {
    const isNumber = value === String(Number(value)) || typeof value === 'number';
    return isNumber ? value.toString() : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/price-rules/rule-condition/rule-condition.component.ts